import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi } from '../../laas/base-api.service';
import { AdminAuthService } from '../admin-auth.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ViewMisService {

  adminId: string;
  baseUrl: string;
  private applicantId: string;
  public isRetail: boolean;

  constructor(
    private api: BaseApi,
  ) {
    this.applicantId = this.getApplicantID();
    this.adminId = sessionStorage.getItem('wl-admin-id');
    this.baseUrl = `/applicants/${this.applicantId}`;

  }

  getApplicantID() {
    return sessionStorage.getItem('wl-applicant-id');
  }

  getUsersSearch(input, roleId, offset, limit, page) {

    let dataObj = {
      "adminId": this.adminId,
      "roleId": this.getRoleId(),
      "filter": input,
      "offset": offset,
      "limit": limit,
      "data_type": "Online",
      "branch_code": sessionStorage.getItem('branch_code'),
      "ro_code": sessionStorage.getItem('ro_code'),
      "zonal_code": sessionStorage.getItem('zonal_code')
    }
    let filterDate = sessionStorage.getItem('filterDateViewOnline') ? sessionStorage.getItem('filterDateViewOnline') : '';
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    return this.api.newPost(`/users/userSearch`, dataObj, true).pipe(map(res => {
      if (!res.result) {
        return '';
      }
      let i = page * 10 - 9;
      if (res && res.result && res.result.resultData) {
        res.result.resultData.forEach(user => user.srNo = i++)
        return res;
      }
    }))
  }

  getUsersFilterDate(input, roleId, offset, limit, filterDate) {

    let dataObj = {
      "adminId": this.adminId,
      "roleId": this.getRoleId(),
      "filter": input,
      "offset": offset,
      "limit": limit,
      "data_type": "Online",
      "filter_date": filterDate,
      "branch_code": sessionStorage.getItem('branch_code'),
      "ro_code": sessionStorage.getItem('ro_code'),
      "zonal_code": sessionStorage.getItem('zonal_code')
    }
    let filterDate1 = sessionStorage.getItem('filterDateViewOnline') ? sessionStorage.getItem('filterDateViewOnline') : '';
    if (filterDate1) {
      let date = new Date(filterDate1);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    return this.api.postRes('/users/userSearch', dataObj).pipe(map(resp => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }



  getUsers(input, roleId, offset, limit) {

    let dataObj = {
      "adminId": this.adminId,
      "roleId": this.getRoleId(),
      "filter": input,
      "offset": offset,
      "limit": limit,
      "data_type": "Online",
      "branch_code": sessionStorage.getItem('branch_code'),
      "ro_code": sessionStorage.getItem('ro_code'),
      "zonal_code": sessionStorage.getItem('zonal_code')
    }
    let filterDate = sessionStorage.getItem('filterDateViewOnline') ? sessionStorage.getItem('filterDateViewOnline') : '';
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    return this.api.postRes('/users/userSearch', dataObj).pipe(map(resp => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      return resp;
    }))

    // return this.api.newPost(`/users/search-users/${page}`, { input: input ? input : '' }, true).map(res => {
    //   if (!res.result) {
    //     return '';
    //   }
    //   let i = page * 10 - 9;
    //   res.result.forEach(user => user.srNo = i++)
    //   return res;
    // })
  }

  generateInvoice(custName, custId, custMail, isRetail) {
    let dataObj = {
      "adminId": this.adminId,
      "custName": custName,
      "custId": custId,
      "email": custMail,
      "isRetail": isRetail,
    }



    return this.api.postRes('/users/generateBill', dataObj).pipe(map(resp => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }

  getRocCounts() {
    return this.api.newGet(`/pdf/getCount/roc`).pipe(map(res => {
      return res;
    }))
  }
  getfreshcasesreport(start_date, end_date, type, id, endpoint, dataNew) {
    // let headers: HttpHeaders = new HttpHeaders();
    // headers.append('route-api-key','fr-re-token-api-route')
    console.log(start_date, end_date, type, id, endpoint)
    let data = {}
    if (type == "Zone") {
      data['zone_code'] = id
      console.log('zone correct cond');
    }
    if (type == "RO") {
      data['ro_code'] = id
      console.log('RO correct cond');
    }
    if (type == "Branch") {
      data['branch_code'] = id
      console.log('Branch correct cond');
    }
    if (type == "CO") {
      data['co_code'] = id
      console.log('co correct cond');
    }
    data['start_date'] = start_date;
    data['end_date'] = end_date;
    data['type'] = type;
    data['user_Id'] = sessionStorage.getItem('wl-admin-id');
    data[dataNew.type] = dataNew[dataNew.type];
    return this.api.postRes(`/${endpoint}`, data)
  }

  getDropDownValues(data) {
    return this.api.postRes(`/blg/getZRBMisFilter`, data)
  }

  generateLogReport() {
    return this.api.newGet(`/pdf/getLogDataForAdmin/${this.adminId}`).pipe(map(report => {
      console.log(report);
      return report;
    }))
  }

  getCoApplicants(custId) {
    return this.api.postRes('/users/getCoApplicants', { custId: custId }).pipe(map(resp => {
      console.log("resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }

  getGuarantors(custId) {
    return this.api.postRes('/users/getguarantors', { custId: custId }).pipe(map(resp => {
      console.log("resp in service " + JSON.stringify(resp));
      return resp;
    }))
  }
  getRoleId() {
    return sessionStorage.getItem('getroleId');
  }



  getStateZrbInfo(data) {
    // let code_type;
    // data.type == "zone"?code_type="zone_code":
    // data.type=="ro"?code_type="zone_code":
    // data.type=="branch"?code_type="ro_code":"";

    // type - Selected Dropdown Value - Organisation level
    // filter -  
    let params = new HttpParams()
      .set('type', data.type.toLowerCase())

    if (data.filter) {
      console.log('here in filter')
      params = new HttpParams()
        .set('type', data.type.toLowerCase())
        .set('filter', data.filter)
    }

    if (data['code_type']) {
      console.log('here in odeType')
      params = new HttpParams()
        .set('type', data.type.toLowerCase())
        .set('filter', data.filter)
        .set(data['code_type'], data['code_value'])
    }
    
    console.log(params)

    return this.api.getAll(`/blg/state-zrb-info`, { params });
  }


}
